<template>
  <div class="navbar-dropdown" :class="{ active }">
    <button
      type="button"
      class="navbar-dropdown__trigger"
      :class="{ current }"
      @click="toggle">
      <slot />
      <i class="fa-solid fa-chevron-down navbar-dropdown__icon" />
    </button>

    <div v-if="active" class="navbar-dropdown__menu">
      <a
        v-for="item in items"
        :key="item.href"
        :href="item.href"
        class="navbar-dropdown__item">
        {{ item.label }}
      </a>
    </div>
  </div>
</template>

<script setup>
import {
  ref, computed, onMounted, onUnmounted
} from 'vue'
import { useGlobalStore } from '@/stores/global'

const props = defineProps({
  items: {
    type: Array,
    required: true
  }
})

const globalStore = useGlobalStore()
const active = ref(false)

const current = computed(() => {
  const path = globalStore.currentPath
  if (!path) return false
  return props.items.some((item) => path.startsWith(item.href.replace(/^\//, '')))
})

function toggle() {
  active.value = !active.value
}

function handleClickOutside(e) {
  if (!e.target.closest('.navbar-dropdown')) {
    active.value = false
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onUnmounted(() => document.removeEventListener('click', handleClickOutside))
</script>
